import { useMemo } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDModal from '../../../shared/antd/ANTDModal'
import ANTDTable from '../../../shared/antd/ANTDTable'

const parsePaymentFormEditLogs = paymentFormEditLogs =>
  paymentFormEditLogs.flatMap((editLog, logIndex) => {
    try {
      const data =
        typeof editLog?.data === 'string'
          ? JSON.parse(editLog.data)
          : editLog?.data || {}

      return (data?.updatedChanges || []).map((change, changeIndex) => ({
        ...change,
        key: `${logIndex}-${changeIndex}`,
        updatedBy: editLog?.userDetails,
      }))
    } catch {
      return []
    }
  })

const ReportEditLogModal = ({ open, onClose, paymentFormEditLogs = [] }) => {
  const { t } = useTranslations()
  const list = useMemo(
    () => parsePaymentFormEditLogs(paymentFormEditLogs),
    [paymentFormEditLogs],
  )

  const columns = [
    {
      title: t('txt_Field'),
      dataIndex: 'label',
      render: value => {
        return value ? t(value) : '-'
      },
    },
    {
      title: t('txt_PreviousValue'),
      dataIndex: 'previousValue',
      render: value => value ?? '-',
    },
    {
      title: t('txt_UpdatedValue'),
      dataIndex: 'updatedValue',
      render: (value, rowData) => value ?? rowData?.requestedValue ?? '-',
    },
    {
      title: t('txt_UpdatedBy'),
      dataIndex: 'updatedBy',
      render: (value, rowData) => {
        const user = value || rowData?.requestedByInfo || rowData?.editedBy
        return user?.businessName || user?.name || user?.lastName || user || '-'
      },
    },
  ]

  return (
    <ANTDModal
      title={t('txt_EditLog')}
      centered
      open={open}
      onCancel={onClose}
      footer={false}
      width={1000}
      destroyOnClose
    >
      <ANTDTable
        className="mt-10"
        dataSource={list}
        columns={columns}
        pagination={false}
        scroll={{ x: 800 }}
      />
    </ANTDModal>
  )
}

export default ReportEditLogModal
